import { STATE_TO_ICON_MAP, PLAY_STATE, PAGINATION_PLAY_EVENT_ACTION_MAP } from './PaginatedPlay.constants';
export function getStateIcon(state) {
  return STATE_TO_ICON_MAP[state];
}
export function getOppositeActionHandler(state, _ref) {
  var play = _ref.play,
    pause = _ref.pause;
  return state === PLAY_STATE ? pause : play;
}
export function getPaginationPlayEventAction(currentState) {
  return PAGINATION_PLAY_EVENT_ACTION_MAP[currentState];
}